import { ECOMemberPassIntegrationState } from './partials/eco-member-pass'
import { ECOPortalIntegrationCaseStatsState } from './partials/eco-portal-case-stats'
import { ECOPortalIntegrationState } from './partials/eco-portal'
import { KioskIntegrationState } from './partials/kiosk'
import { OWRIntegrationState } from './partials/owr'
import { SignupIntegrationState } from './partials/signup'
import { TmetricState } from './partials/tmetric'

export const IntegrationState = _ => ({
  ...ECOMemberPassIntegrationState,
  ...ECOPortalIntegrationCaseStatsState,
  ...ECOPortalIntegrationState,
  ...KioskIntegrationState,
  ...OWRIntegrationState,
  ...SignupIntegrationState,
  ...TmetricState,
})
